<template>
  <div
    class="wrapper"
    :class="{ open: open, 'opaque-bg': !transparentMode, 'mobile': isMobile, 'postit': !transparentMode && isMobile }"
    :style="isMobile ? `height: ${mobileWrapperHeight}px` : ''"
    v-click-outside="onClickOutside"
  >
    <div
      ref="collapsed"
      v-if="!open || isMobile"
      class="flex w-full p-4"
      :class="isMobile ? 'flex-row justify-between items-center' : 'flex-col justify-end h-full'"
    >
      <QuestionBox
        v-if="!isMobile"
        @click.native="$router.push('/about')"
        class="mb-4 cursor-pointer icon"
        :class="{ 'bg-white': transparentMode }"
      />
      <template v-else>
        <router-link
          v-if="!open && this.$route.path === '/' && mobileScrollText"
          :to="mobileScrollText.uri"
          class="truncate cursor-pointer"
          style="max-width:75%"
        >
          {{ mobileScrollText.title }}
        </router-link>
        <div v-else-if="pathDepth === 2" v-on:click="goBack()" class="cursor-pointer">
          Back
        </div>
        <div v-else-if="pathDepth === 1" v-on:click="$router.push('/')" class="cursor-pointer">
          Home
        </div>
        <div v-else>
          EER
        </div>
      </template>
      <Hamburger
        @click.native="setOpen(!open)"
        class="cursor-pointer icon"
        :class="{'py-2': isMobile}"
        id="hamburger"
      />
    </div>
    <transition name="fade" mode="in-out">
      <div
        id="expanded"
        ref="expanded"
        v-if="open"
        class="w-full h-full flex flex-col"
        :class="isMobile ? 'px-6 py-0' : 'p-6'"
      >
        <div v-if="!isMobile" class="pt-2 pb-6">
          <div v-if="!isMobile" class="pb-4">EER</div>
          <h1><router-link to="/activities" @click.native="setOpen(false)">Activities</router-link></h1>
          <h1><router-link to="/events" @click.native="setOpen(false)">Events</router-link></h1>
          <h1><router-link to="/artworks" @click.native="setOpen(false)">Artworks</router-link></h1>
          <h1><router-link to="/about" @click.native="setOpen(false)">About</router-link></h1>
        </div>
        <div class="my-4" :class="{'flex-grow': !isMobile}">
          <div v-html="text" :class="{'line-clamp': isMobile}" />
          <span v-if="isMobile" class="underline cursor-pointer" @click="setOpen(false); $router.push('/about')">Read more</span>
        </div>
        <div v-if="isMobile" class="py-2 mb-2">
          <h1><router-link to="/activities" @click.native="setOpen(false)">Activities</router-link></h1>
          <h1><router-link to="/events" @click.native="setOpen(false)">Events</router-link></h1>
          <h1><router-link to="/artworks" @click.native="setOpen(false)">Artworks</router-link></h1>
          <h1><router-link to="/about" @click.native="setOpen(false)">About</router-link></h1>
        </div>
        <div v-if="!isMobile" class="flex flex-row justify-between">
          <div>
            <router-link to="/privacy" @click.native="osetOpen(false)">Privacy</router-link>
          </div>
          <div v-if="!isMobile">
            <Close @click.native="setOpen(false)" class="cursor-pointer icon-sm" />
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import vClickOutside from 'v-click-outside'
import QuestionBox from '@/components/icons/QuestionBox'
import Hamburger from '@/components/icons/Hamburger'
import Close from '@/components/icons/Close'

export default {
  name: 'MainMenu',

  components: {
    Hamburger,
    QuestionBox,
    Close
  },

  directives: {
    clickOutside: vClickOutside.directive
  },

  props: ['transparentMode', 'text', 'triggerOpen', 'isMobile', 'mobileScrollText'],

  watch: {
    triggerOpen (val) {
      this.setOpen(val)
    },

    $route (to) {
      if (this.isMobile && to.path === '/') {
        setTimeout(() => {
          this.updateMobileHeight()
        }, 100)
      }
    }
  },

  data () {
    return {
      open: false,
      mobileWrapperHeight: 74
    }
  },

  computed: {
    pathDepth () {
      return this.$route.path.split('/').filter(p => p !== '').length
    }
  },

  methods: {
    setOpen (isOpen) {
      this.open = isOpen
      this.$emit('isOpen', this.open)

      if (this.isMobile) {
        this.updateMobileHeight()
      }
    },

    updateMobileHeight () {
      if (this.$route.path === '/') {
        this.$nextTick(() => {
          const collapsed = this.$refs['collapsed']
          const expanded = this.$refs['expanded']
          if (expanded) {
            this.mobileWrapperHeight = collapsed.clientHeight + expanded.clientHeight
          } else {
            this.mobileWrapperHeight = collapsed.clientHeight
          }
        })
      } else {
        if (this.open) {
          this.mobileWrapperHeight = window.innerHeight
        } else {
          this.mobileWrapperHeight = 74
        }
      }
    },

    onClickOutside (event) {
      if (event.target.id !== 'hamburger') {
        this.setOpen(false)
      }
    },

    handleScroll () {
      if (this.open && window.scrollY !== 0) {
        this.setOpen(false)
      } else {
        if (this.$route.path === '/' && window.scrollY === 0) {
          this.setOpen(true)
        }
      }
    },

    handleResize () {
      this.updateMobileHeight()
    },

    goBack () {
      if (document.referrer.includes(window.location.host)) {
        this.$router.go(-1)
      } else {
        this.$router.push('/')
      }
    }
  },

  created () {
    window.addEventListener('scroll', this.handleScroll)

    if (this.isMobile) {
      window.addEventListener('resize', this.handleResize)
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)

    if (this.isMobile) {
      window.removeEventListener('resize', this.handleResize)
    }
  }
}

</script>

<style scoped lang="stylus">
a {
  text-decoration: none !important;
}

a:hover {
  text-decoration: underline;
}

.wrapper {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 88px;
  height: calc(50% + 33px);
  transition: all .25s ease-out;
  background: transparent;
  border-top: 1px solid transparent;
  border-left: 1px solid transparent;
  border-bottom: 1px solid transparent;
  z-index: 20;
  overflow: hidden;
}

.wrapper.mobile {
  top: 0;
  bottom: unset;
  left: 0;
  right: unset;
  background: white;
  height: calc(42px + 2rem);
  border: none;
  width: 100%;
}

.wrapper.mobile.postit {
  width: calc(100% - 2rem);
  margin: 1rem;
  -webkit-box-shadow: 0px 4px 7px -2px rgba(0,0,0,0.58);
  -moz-box-shadow: 0px 4px 7px -2px rgba(0,0,0,0.58);
  box-shadow: 0px 4px 7px -2px rgba(0,0,0,0.58);
}

.opaque-bg {
  background: white;
  border-top: 1px solid black;
  border-left: 1px solid black;
  border-bottom: 1px solid black;
}

.open {
  background: white;
  border-top: 1px solid black;
  border-left: 1px solid black;
  border-bottom: 1px solid black;
}

.wrapper.open {
  width: 423px;
  max-width: 100%;
  height: calc(100vh - 64px);
}

.wrapper.open.mobile {
  width: 100%;
  border: none;
}

.wrapper.open.mobile.postit {
  width: calc(100% - 2rem);
}

.mobile #expanded {
  height: auto;
}

.icon {
  width: calc(87px - 2rem);
  height: auto;
}

.icon-sm {
  width: 24px;
  height: auto;
}

.line-clamp {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 10;
  -webkit-box-orient: vertical;
}

.line-clamp >>> p {
  margin: 0;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .25s;
}

.fade-enter-active {
  transition-delay: .25s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>